import { Injectable } from '@angular/core';
import {SharedService} from './shared.service';
import {environment} from '../../environments/environment';
import {ToastService} from './toast.service';
import {GridService} from './grid.service';
import {ProgressBarsService} from './progress-bars.service';
import { AuthService } from './auth.service';
import {LocalStorageService} from './local-storage.service';
import {throwError} from 'rxjs';
import {InfoService} from './info.service';
import {RowNode} from 'ag-grid-community';
import { StorageService } from './storage.service';
import {Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {AiReportDialogComponent} from '../components/dialog/ai-report-dialog/ai-report-dialog.component';
import {deepmerge} from "deepmerge-ts";
import { ImageSyncService } from './image-sync.service';
import { WeightEstimatorService } from './weight-estimator.service';

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {
  private webSocket: any;
  private connected = false;
  private pongInterval: any;
  private checkConnectInterval: any;
  private errorMessage?: number;

  private shopifySyncComplete: number = 0;
  private shopifySyncTotalItems: number = 0;
  private shopifySyncInitialTotal: number = 0; // Store the initial total for accurate tracking
  private startFeedGeneratorMessageTimer: any = null;

  public appReady: boolean = false;

  constructor(
    private sharedService: SharedService,
    private toastService: ToastService,
    private router: Router,
    private gridService: GridService,
    private progressBarsService: ProgressBarsService,
    private authService: AuthService,
    private localStorageService: LocalStorageService,
    private infoService: InfoService,
    private storageService: StorageService,
    private dialog: MatDialog,
    private imageSyncService: ImageSyncService,
    private weightEstimatorService: WeightEstimatorService,
  ) {
    this.checkConnect();
    this.pingPong();
    this.authService.refreshToken$.subscribe(res => {
      if (res && this.connected) {
        clearInterval(this.checkConnectInterval);
        this.webSocket.close();
        this.connect();
      }
    });
  }

  public connect(cb?: any): any {
    const accessToken: any = this.localStorageService.getItem('accessToken');

    this.webSocket = new WebSocket(environment.WS_PATH + `?token=${accessToken}`);
    this.webSocket.onopen = (ev: any) => {
      this.connected = true;
      // this.webSocket.send(JSON.stringify({}));
      this.infoService.$appReady.next(true);
      if (cb) { cb(); }
    }
    this.webSocket.onmessage = this.messageHandler;
    this.webSocket.onerror = this.onError;
    this.webSocket.onclose = this.onClose;
  }

  public send(message: any) {
    this.webSocket.send(JSON.stringify(message));
  }

  public reConnect(): void {
    if (this.connected) {
      clearInterval(this.checkConnectInterval);
      this.webSocket.close();
      this.connect();
    }
  }

  private checkConnect(): void {
    this.checkConnectInterval = setInterval(() => {
      if (!this.connected) {
        if (!this.errorMessage) {
          // this.errorMessage = this.toastService.error('WebSocket is not connected').toastId;
        }
        this.connect(() => {
          // this.toastService.removeMessage(this.errorMessage);
          // this.toastService.info('WebSocket is connected');
        });
      }
    }, 10000);
  }

  private messageHandler = (event: any): void => {
    const msg = JSON.parse(event.data);


    if (msg.info) {
      if (msg.info.stageModifiedProductsCounter !== undefined) {
        this.infoService.stageModifiedProductsCounter.next(msg.info.stageModifiedProductsCounter);
        this.infoService.productionModifiedProductsCounter.next(msg.info.stageModifiedProductsCounter);
      }
    }
    if (msg.event === 'ai-rename-complete') {
      this.toastService.success('ai-rename-complete');
      // this.dialog.open(AiReportDialogComponent, {
      //   width: '80%',
      //   maxWidth: '1024px',
      //   disableClose: true,
      // });
    } else if (msg.event === 'ai-tags-update') {
      const payload = msg.payload;
      if (payload.pids) {
        for (const product_id of payload.pids) {
          this.gridService.aiTagsGridApi?.forEachNode((rowNode: RowNode) => {
            if (rowNode.data && rowNode.data.product_id === product_id) {
              if (rowNode.data.ai_tags === undefined) {
                rowNode.data.ai_tags = {};
              }
              if (payload.step_1) {
                rowNode.data.ai_tags.step_1 = payload.step_1;
              }
              if (payload.step_2) {
                rowNode.data.ai_tags.step_2 = payload.step_2;
              }
              if (payload.step_3) {
                rowNode.data.ai_tags.step_3 = payload.step_3;
              }
              if (payload.step_4) {
                rowNode.data.ai_tags.step_4 = payload.step_4;
              }

              const rowData = deepmerge(rowNode.data, payload);
              rowNode.setData(rowData);
            }
          });
        }
      } else {
        this.gridService.aiTagsGridApi?.forEachNode((rowNode: RowNode) => {
          if (rowNode.data && rowNode.data.product_id === payload.product_id) {
            if (rowNode.data.ai_tags === undefined) {
              rowNode.data.ai_tags = {};
            }
            if (payload.step_1) {
              rowNode.data.ai_tags.step_1 = payload.step_1;
            }
            if (payload.step_2) {
              rowNode.data.ai_tags.step_2 = payload.step_2;
            }
            if (payload.step_3) {
              rowNode.data.ai_tags.step_3 = payload.step_3;
            }
            if (payload.step_4) {
              rowNode.data.ai_tags.step_4 = payload.step_4;
            }

            const rowData = deepmerge(rowNode.data, payload);
            rowNode.setData(rowData);
          }
        });
      }
    } else if (msg.event === 'product-update') {
      // this.productUpdateHandler(msg);
    } else if (msg.event === 'bulk-edit-close') {
      const currentUser = this.localStorageService.getItem('user');
      if (currentUser && currentUser._id === msg.payload.user_id) {
        if (this.dialog.openDialogs && this.dialog.openDialogs[0] && this.dialog.openDialogs[0].id === 'bulkEditDialog') {
          this.dialog.closeAll();
        }
      }
    } else if (msg.event ==='update-new-after-reject') {
      if (this.checkActiveGrid(this.gridService.gridApi)) {
        this.gridService.gridApi?.refreshServerSide({purge: true});
      } else if (this.checkActiveGrid(this.gridService.changesGridApi)) {
        this.gridService.changesGridApi?.refreshServerSide({purge: true});
      }
    } else if (msg.event === 'restart-app') {
      this.gridService.gridApi?.showLoadingOverlay();
      this.gridService.productionGridApi?.showLoadingOverlay();
      this.gridService.changesGridApi?.showLoadingOverlay();
      this.gridService.historyGridApi?.showLoadingOverlay();
      setTimeout(() => {
        window.location.reload();
      }, 8000);
    } else if (msg.event === 'aiFineTuneGptComplete') {
      this.gridService.aiFineTuneGptCompleteEvent.next(true);
    } else if (msg.event === 'aiFineTuneGptComplete_all') {
      this.gridService.aiFineTuneGptCompleteAllEvent.next(true);
    } else if (msg.event === 'ai-save-complete') {
      // this.toastService.success('The work is done', '', {
      //   timeOut: 0
      // });
      this.gridService.aiUpdateResultsTable$.next(true);
      // this.gridService.aiCompleteJob$.next(true);
    } else if (msg.event ==='gptQuery-ai') {
      this.gridService.aiGptParser$.next(msg.payload);
    } else if (msg.event === 'ai-complete') {
      this.gridService.aiGrid1Ready$.next(true);
    } else if (msg.event === 'ai-update-result') {
      this.gridService.aiUpdateResultsTable$.next(true);
    } else if (msg.event === 'ai-price') {
      // this.toastService.info(`Request price: ~ $${msg.payload.price}`, '', {
      //   timeOut: 8000
      // });
    } else if (msg.event === 'weight-estimator') {
      this.weightEstimatorService.events$.next(msg);
    } else if (msg.event === 'product-restore') {
      this.productRestoreHandler(msg);
    } else if (msg.event === 'filterByFileProducts_sku') {
      const currentUser = this.localStorageService.getItem('user');
      if (currentUser && currentUser._id === msg.user) {
        if (msg.environment === 'stage') {
          this.router.navigateByUrl('/grid').then(() => {
            setTimeout(() => {
              this.gridService.gridApi?.setFilterModel({
                sku: {
                  filterType: 'text',
                  type: 'contains',
                  filter: msg.products
                }
              });
            }, 300);
          });
        } else if (msg.environment === 'production') {
          this.router.navigateByUrl('/grid/production').then(() => {
            setTimeout(() => {
              this.gridService.productionGridApi?.setFilterModel({
                sku: {
                  filterType: 'text',
                  type: 'contains',
                  filter: msg.products
                }
              });
            }, 300);
          });
        }
      }
    } else if (msg.event === 'filterByFileProducts_id') {
      const currentUser = this.localStorageService.getItem('user');
      if (currentUser && currentUser._id === msg.user) {
        if (msg.environment === 'stage') {
          this.router.navigateByUrl('/grid').then(() => {
            setTimeout(() => {
              this.gridService.gridApi?.setFilterModel({
                product_id: {
                  filterType: 'text',
                  type: 'contains',
                  filter: msg.products
                }
              });
            }, 300);
          });
        } else if (msg.environment === 'production') {
          this.router.navigateByUrl('/grid/production').then(() => {
            setTimeout(() => {
              this.gridService.productionGridApi?.setFilterModel({
                product_id: {
                  filterType: 'text',
                  type: 'contains',
                  filter: msg.products
                }
              });
            }, 300);
          });
        } else if (msg.environment === 'delete') {
          this.router.navigateByUrl('/delete').then(() => {
            setTimeout(() => {
              this.gridService.gridApi?.setFilterModel({
                product_id: {
                  filterType: 'text',
                  type: 'contains',
                  filter: msg.products
                }
              });
            }, 300);
          });
        }
      }
    } else if (msg.event === 'goToProdSync') {
      const currentUser = this.localStorageService.getItem('user');
      if (currentUser && currentUser._id === msg.user) {
        this.router.navigateByUrl('/grid/production').then(() => {
          this.gridService.changesGridApi?.hideOverlay();
          setTimeout(() => {
            this.gridService.productionGridApi?.setFilterModel({
              _id: {
                filterType: 'text',
                type: 'contains',
                filter: msg.products
              }
            });
          }, 300);
        });
      }
    } else if (msg.event === 'bulk-info') {
      this.bulkEditHandler(msg);
    } else if (msg.event === 'shopify-sync-errors') {
      this.shopifyErrorsHandler(msg);
    } else if (msg.event === 'shopify-sync' && msg.type === 'start') {
      this.shopifySyncStartHandler(msg);
    } else if (msg.event === 'shopify-sync' && msg.type === 'update') {
      this.shopifySyncUpdateHandler(msg);
    } else if (msg.event === 'shopify-sync' && msg.type === 'bulk-status') {
      this.progressBarsService.setBulkSyncStatus(msg.payload);
    } else if (msg.event === 'shopify-sync' && msg.type !== 'complete' && msg.type !== 'delete-complete' && msg.type !== 'counter' && msg.type !== 'start' && msg.type !== 'update' && msg.type !== 'bulk-status') {
      this.shopifyHandler(msg);
    } else if (msg.event === 'shopify-sync' && msg.type === 'counter') {
      this.shopifyCounterHandler(msg);
    } else if (msg.event === 'shopify-sync' && msg.type === 'complete') {
      this.shopifyCompleteHandler(msg);
    } else if (msg.event === 'shopify-images-sync' && msg.type === 'complete') {
      this.shopifyImagesCompleteHandler(msg);
    } else if (msg.event === 'shopify-sync' && msg.type === 'delete-complete') {
      this.progressBarsService.setShopifyValue(0);
      this.progressBarsService.setShopifyPendingStatus(false);
      this.progressBarsService.setShopifyCounter(0);
      this.toastService.success('All selected products have been successfully removed!', '', {
        timeOut: 0,
        extendedTimeOut: 0,
        closeButton: true,
      });
      if (this.checkActiveGrid(this.gridService.gridApi)) {
        this.gridService.gridApi?.refreshServerSide({purge: true});
      }
      if (this.checkActiveGrid(this.gridService.productionGridApi)) {
        this.gridService.productionGridApi?.refreshServerSide({purge: true});
      }
    } else if (msg.event === 'user') {
      this.userHandler(msg);
    } else if (msg.event === 'feed-info') {
      this.feedHandler(msg);
    } else if (msg.event === 'feed') {
      this.feedHandler(msg);
    } else if (msg.event === 'sync-health') {
      this.syncHealthHandler(msg);
    } else if (msg.event === 'import-update') {
      this.importUpdateHandler(msg);
    } else if (msg.event === 'import-analysis') {
      this.progressBarsService.updateImportAnalysis(msg.type === 'complete' ? null : msg.payload);
    } else if (msg.event === 'gmc-feed') {
      this.gmcFeedHandler(msg);
    } else if (msg.event === 'import-create') {
      this.importCreateHandler(msg);
    } else if (msg.event === 'error') {
      this.errorHandler(msg);
    } else if (msg.event === 'push-to-production') {
      this.pushToProductionHandler(msg);
    } else if (msg.event === 'export') {
      this.exportHandler(msg);
    } else if (msg.event === 'bulk-edit') {
      this.newBulkEditHandler(msg);
    } else if (msg.event === 'custom-message') {
      this.customMessageHandler(msg);
    } else if (msg.event === 'tags') {
      this.tagsHandler(msg);
    } else if (msg.event === 'image-sync-status') {
      this.imageSyncStatusHandler(msg);
    } else if (msg.event === 'image-sync-progress') {
      this.imageSyncProgressHandler(msg);
    } else if (msg.event === 'image-sync') {
      this.imageSyncUpdateHandler(msg);
    } else if (msg.event === 'image-sync-error') {
      this.imageSyncErrorHandler(msg);
    }

    if (msg.event === 'backup-restore') {
      if (msg.type === 'complete') {
        this.gridService.gridApi?.refreshServerSide();
        this.gridService.productionGridApi?.refreshServerSide();
        this.gridService.historyGridApi?.refreshServerSide();
        this.gridService.changesGridApi?.refreshServerSide();

        this.gridService.gridApi?.hideOverlay();
        this.gridService.productionGridApi?.hideOverlay();
        this.gridService.historyGridApi?.hideOverlay();
        this.gridService.changesGridApi?.hideOverlay();
      }
    }

    if (msg.event === 'backup') {
      if (msg.type === 'pending') {
        this.gridService.gridApi?.showLoadingOverlay();
        this.gridService.productionGridApi?.showLoadingOverlay();
        this.gridService.historyGridApi?.showLoadingOverlay();
        this.gridService.changesGridApi?.showLoadingOverlay();
      }
      if (msg.type === 'complete') {
        this.gridService.gridApi?.hideOverlay();
        this.gridService.productionGridApi?.hideOverlay();
        this.gridService.historyGridApi?.hideOverlay();
        this.gridService.changesGridApi?.hideOverlay();
      }
    }

    if (msg.type === 'memory') {
      this.gridService.availableRam$.next(msg.allFreeMem);
      // Older API builds send no `stats`; leave the last value in place rather
      // than blanking the widget when one tick arrives without it.
      if (msg.stats) {
        this.gridService.systemStats$.next(msg.stats);
      }
      if (msg.presence) {
        this.gridService.presence$.next(msg.presence);
      }
    }
    // new
    if (msg.event === 'product') {
      if (msg.type === 'delete') {
        this.productDeleteHandler(msg);
      }

      if (msg.type === 'update') {
        this.productUpdateHandler(msg);
      }

      if (msg.type === 'unlock') {
        this.gridService.stageUnlockProductsRowUpdate(msg.payload);
      }

      if (msg.type === 'lock') {
        this.gridService.stageLockProductsRowUpdate(msg.payload);
      }

      if (msg.totalWaiting || msg.totalWaiting === 0) {
        this.shopifyHandler(msg);
      }
    }
    if (msg.event === 'info') {
      this.infoHandler(msg);
    }
    if (msg.event === 'production') {
      this.productionHandler(msg);
    }
  }

  private customMessageHandler(data: any): void {
    this.toastService.info(data.message);
  }

  private gmcFeedHandler(data: any): void {
    if (data.type === 'complete') {
      this.toastService.success(`GMC feed successfully updated`, '', {
        disableTimeOut: false,
        timeOut: 10000
      });
      this.progressBarsService.setBulkValue(0);
      // this.progressBarsService.shopifySyncPendingStatus
      this.progressBarsService.setShopifyPendingStatus(false);
    }

    if (data.type === 'start') {
      this.toastService.info('GMC data is being exported...', '');
      this.progressBarsService.setBulkValue(1);
    }

    if (data.type === 'pending') {
      this.progressBarsService.setBulkValue(1);
    }
  }

  private pushToProductionHandler(data: any): void {
    if (data.type === 'progress') {
      this.progressBarsService.updatePushProgress(
        data.payload?.phase || 'confirming',
        data.payload?.completed || 0,
        data.payload?.total || 0,
        data.payload?.percentage || 0
      );
      return;
    }
    if (data.type === 'complete') {
      this.toastService.info('All approved changes have been pushed to Production DB successfully! Please, sync them.');
      this.gridService.changesGridApi?.hideOverlay();
      this.gridService.changesGridApi?.refreshServerSide();
      this.infoService.pushToProductionComplete.next(true);
      this.progressBarsService.endImport();
    }
  }

  private onceExportHandlerMessage: boolean = true;
  private exportHandler(data: any): void {
    if (data.type === 'download' && this.onceExportHandlerMessage) {
      this.onceExportHandlerMessage = false;
      let exportMessage = '';

      if (data.exportMessage) {
        exportMessage = data.exportMessage + '.'
      }

      const currentUser = this.authService.user$.getValue();
      // if (currentUser && currentUser._id === data.payload.user) {
      this.toastService.removeMessage(this.sharedService.exportMessageId);
        this.toastService.warning(`Data export completed successfully! ${exportMessage} <a target="_blank" href="${environment.API_PATH + data.payload.file}">Click here</a> to download the file.`, '', {
          // Deliberately sticky: this toast carries the download link the
          // user must click — it stays until dismissed via the close button.
          disableTimeOut: true,
          enableHtml: true,
          tapToDismiss: false,
          newestOnTop: false,
        });
        // this.toastService.success('<a href="ya.ru">asd</a>', '', {enableHtml: true});
        // window.open(environment.API_PATH + data.payload.file);
      // }
      setTimeout(() => {
        this.onceExportHandlerMessage = true;
      }, 1000);
    } else if (data.type === 'error') {
      this.toastService.error(data.message, '', {
        disableTimeOut: true,
        enableHtml: true
      });
    }
  }

  private productionHandler(data: any): void {
    if (data.type === 'push') {
      this.gridService.refreshChangesGrid();
    }
  }

  private tagsHandler(data: any): void {
    if (data.type === 'update') {
      Promise.all([
        this.storageService.getTags(),
        this.storageService.getVendorTags(),
      ]).then(() => {
        this.gridService.refreshMetadataCells();
      });
    }
  }

  private imageSyncStatusHandler(data: any): void {
    if (data.type === 'scan-started' || data.type === 'sync-started') {
      this.imageSyncService.updateStatus({
        type: data.type,
        message: data.payload?.message || 'Processing...',
        payload: data.payload
      });
    } else if (data.type === 'scan-completed' || data.type === 'sync-completed') {
      // For scan-completed, the backend now sends full results in the payload
      this.imageSyncService.updateStatus({
        type: data.type,
        message: data.payload?.message || 'Completed',
        payload: data.payload
      });
    }
  }

  private imageSyncProgressHandler(data: any): void {
    if (data.payload) {
      this.imageSyncService.updateProgress({
        completed: data.payload.completed || 0,
        total: data.payload.total || 0,
        percentage: data.payload.percentage || 0,
        type: data.type
      });
    }
  }

  private imageSyncUpdateHandler(data: any): void {
    if (data.payload) {
      this.imageSyncService.updateItem({
        _id: data.payload._id,
        sku: data.payload.sku,
        title: data.payload.title,
        imageUrl: data.payload.imageUrl,
        synced: data.payload.synced,
        action: data.payload.action,
        error: data.payload.error
      });
    }
  }

  private imageSyncErrorHandler(data: any): void {
    if (data.payload) {
      this.imageSyncService.handleError({
        error: data.payload.error || 'Unknown error',
        type: data.type
      });
    }
  }

  private infoHandler(data: any): void {
    // if (data.type === 'changes-table') {
    this.gridService.historyChangesCounter$.next(data.payload.changesForApprove);
    this.gridService.disapproveCounter$.next(data.payload.disapprove);
    this.gridService.stageChangesCounter$.next(data.payload.changes);
    this.gridService.productionChangesCounter$.next(data.payload.productionChanges);
    // }
    this.gridService.historyConflictCounter$.next(data.payload.conflicts);
    this.gridService.historyApprovedCounter$.next(data.payload.approved);
    if (data.type === 'history') {
      this.gridService.gridApi?.forEachNode((rowNode: RowNode) => {
        if (rowNode.data && rowNode.data._id === data.payload._id) {
          let rowData = rowNode.data;
          if (!rowData.changes_fields_log) {
            rowData.changes_fields_log = {}
          }
          rowData.changes_fields_log[data.payload.field] = true;
          rowNode.setData(rowData);
        }
      });
    }
  }

  private checkActiveGrid(gridApi: any): boolean {
    return !!(gridApi && gridApi.destroyCalled === false);
  }

//Grid API function applyTransaction() cannot be called as the grid has been destroyed.
// Please don't call grid API functions on destroyed grids - as a matter of fact you shouldn't
// be keeping the API reference, your application has a memory leak! Remove the API reference
// when the grid is destroyed.

  private productDeleteHandler(data: any): void {
    if (this.checkActiveGrid(this.gridService.productionGridApi)) {
      this.gridService.productionGridApi?.forEachNode((rowNode: RowNode) => {
        if (rowNode.data && rowNode.data._id === data.payload._id) {
          rowNode.data.successfullyDeleted = true;
          this.gridService.productionRowUpdate(rowNode.data);
        }
      });
    }
    if (this.checkActiveGrid(this.gridService.gridApi)) {
      this.gridService.gridApi?.forEachNode((rowNode: RowNode) => {
        if (rowNode.data && rowNode.data._id === data.payload._id) {
          rowNode.data.successfullyDeleted = true;
          this.gridService.rowUpdate(rowNode.data);
        }
      });
    }
  }

  private timerUpdate: any = null;
  // Track last sync status validation to prevent redundant checks
  private lastSyncStatusCheck: number = 0;
  private syncStatusCheckInterval: any;

  private productUpdateHandler(data: any): void {
    const {environment} = data;
    // console.log('this.authService.currentUserValue.id', this.authService.currentUserValue.id);
    // console.log('data.user', data);
    // if (data.user === this.authService.currentUserValue.id) {
    if (environment && environment === 'production') {
      this.gridService.productionRowUpdate(data.payload);

      // CRITICAL FIX: Additional validation for sync status updates
      // If we receive a sync completion status (10 or 80), ensure grid is properly refreshed
      if (data.payload && data.payload.status !== undefined &&
          (data.payload.status === 10 || data.payload.status === 80)) {
        // Schedule a validation check to ensure status is properly reflected
        this.scheduleSyncStatusValidation();
      }
    } else if (environment && environment === 'stage') {
      this.gridService.rowUpdate(data.payload, data.args);
    }
    // clearTimeout(this.timerUpdate);
    // this.timerUpdate = setTimeout(() => {
    //   // this.gridService.getChangesItems();
    //   // this.gridService.getChangesItemsFromLogs();
    // }, 1000);
    // }
  }

  // New method to validate sync status after updates
  private scheduleSyncStatusValidation(): void {
    const now = Date.now();
    // Only schedule if we haven't checked in the last 2 seconds
    if (now - this.lastSyncStatusCheck > 2000) {
      this.lastSyncStatusCheck = now;

      clearTimeout(this.syncStatusCheckInterval);
      this.syncStatusCheckInterval = setTimeout(() => {
        // Skip refresh if user is currently editing a cell to prevent focus loss
        if (this.gridService.isAnyGridEditing()) {
          return;
        }
        // Force a server-side refresh to ensure sync status is current
        if (this.checkActiveGrid(this.gridService.productionGridApi)) {
          this.gridService.productionGridApi?.refreshServerSide();
        }
        if (this.checkActiveGrid(this.gridService.gridApi)) {
          this.gridService.gridApi?.refreshServerSide();
        }
      }, 1000); // Wait 1 second to batch multiple updates
    }
  }

  // Start periodic validation during active sync to catch missed updates
  private startPeriodicSyncValidation(): void {
    // Clear any existing interval
    clearInterval(this.syncInProgressChecker);

    // Set up periodic refresh every 10 seconds during sync (reduced frequency)
    this.syncInProgressChecker = setInterval(() => {
      // Only refresh if we're actively syncing using the initial total as reference
      if (this.shopifySyncInitialTotal > 0 && this.shopifySyncComplete < this.shopifySyncInitialTotal) {
        // Skip refresh if user is currently editing a cell to prevent focus loss
        if (this.gridService.isAnyGridEditing()) {
          return;
        }
        // Light refresh without purge to maintain performance
        if (this.checkActiveGrid(this.gridService.productionGridApi)) {
          this.gridService.productionGridApi?.refreshServerSide();
        }
      } else {
        // Stop checking if sync appears complete
        clearInterval(this.syncInProgressChecker);
      }
    }, 10000); // Check every 10 seconds (reduced from 5 to avoid too frequent updates)
  }

  // Timer for post-sync refresh scheduling
  private postSyncRefreshTimer: any = null;
  private postSyncRefreshAttempts: number = 0;
  private readonly MAX_POST_SYNC_REFRESH_ATTEMPTS = 30; // Max 30 attempts (30 seconds)

  /**
   * Schedule a grid refresh after sync completes, but defer if user is editing.
   * Will retry every second until the user stops editing, up to 30 seconds.
   */
  private schedulePostSyncRefresh(): void {
    // Clear any existing timer
    if (this.postSyncRefreshTimer) {
      clearTimeout(this.postSyncRefreshTimer);
    }
    this.postSyncRefreshAttempts = 0;
    this.attemptPostSyncRefresh();
  }

  private attemptPostSyncRefresh(): void {
    this.postSyncRefreshAttempts++;

    // If user is editing, defer the refresh
    if (this.gridService.isAnyGridEditing()) {
      // Stop trying after max attempts to prevent infinite loops
      if (this.postSyncRefreshAttempts < this.MAX_POST_SYNC_REFRESH_ATTEMPTS) {
        this.postSyncRefreshTimer = setTimeout(() => this.attemptPostSyncRefresh(), 1000);
      }
      return;
    }

    // Refresh production grid (most important as this shows sync status)
    if (this.checkActiveGrid(this.gridService.productionGridApi)) {
      this.gridService.productionGridApi?.refreshServerSide({purge: true});
    }

    // Also refresh main grid if it's active
    if (this.checkActiveGrid(this.gridService.gridApi)) {
      this.gridService.gridApi?.refreshServerSide({purge: true});
    }

    // Refresh changes grid if active (might show pending sync items)
    if (this.checkActiveGrid(this.gridService.changesGridApi)) {
      this.gridService.changesGridApi?.refreshServerSide({purge: true});
    }

    // Add a delayed secondary refresh to catch any timing issues
    // Also respects editing state
    setTimeout(() => {
      if (!this.gridService.isAnyGridEditing()) {
        if (this.checkActiveGrid(this.gridService.productionGridApi)) {
          this.gridService.productionGridApi?.refreshServerSide();
        }
        if (this.checkActiveGrid(this.gridService.gridApi)) {
          this.gridService.gridApi?.refreshServerSide();
        }
      }
    }, 1500);
  }

  private productRestoreHandler(data: any): void {
    this.gridService.rowUpdate({...data.payload, ...{id: data.product_id}});
  }

  private errorHandler(data: any): void {
    if (data.message === '0x239359253') {
      this.toastService.error('Some products are out of sync. \n Click on this message to show them.', 'Shopify Sync').onTap.subscribe(res => {
        this.gridService.gridApi?.setFilterModel({
          id: {
            filterType: 'text',
            type: 'contains',
            filter: data.data.map((x: any) => x.id)
          }
        });
      });
    } else if (data.message === '0x0001') {
      this.toastService.error(data.data, 'DB Error');
    } else {
      this.toastService.error(data.message);
    }
  }

  private onceImportCreateHandler: boolean = true;
  private importCreateHandler(data: any): void {
    if (data.type === 'start') {
      this.progressBarsService.startImport(
        data.payload?.operation || 'create',
        data.payload?.user_name || 'Someone',
        data.payload?.count || 0
      );
      return;
    }
    if (data.type === 'end') {
      this.progressBarsService.endImport();
      return;
    }
    if (data.type === 'complete') {
      this.progressBarsService.setBulkValue(0);
      this.infoService.productionImportCreateComplete.next(true);
      let message = '';
      if (data.payload.count === 1) {
        message = `${data.payload.count} product created successfully`;
      } else {
        message = `${data.payload.count} products created successfully`;
      }
      if (this.onceImportCreateHandler) {
        this.onceImportCreateHandler = false;
        this.toastService.success(message, 'Import Data', {
          timeOut: 10000
        });
        this.gridService.gridApi?.setFilterModel(null);
        this.gridService.gridApi?.setFilterModel({
          imported: {
            filterType: 'set',
            values: [this.authService.currentUserValue._id]
          }
        });
        this.gridService.gridApi?.refreshServerSideStore();
        setTimeout(() => {
          this.onceImportCreateHandler = true;
        }, 3000)
      }
      // this.progressBarsService.setImportCreateValue(0);
      // this.gridService.gridApi?.setFilterModel(null);
      // this.gridService.gridApi?.setFilterModel({
      //   id: {
      //     filterType: 'text',
      //     type: 'contains',
      //     filter: data.returnIds
      //   }
      // });
    }
    // if (data.message === 'progress') {
    //   this.progressBarsService.setImportCreateValue(1);
    // }
  }

  // Sync-pipeline health. These are the failures that used to be completely
  // silent: Redis unreachable, a run that stops moving, or a lock left behind
  // by a crashed sync. Each one blocked every user's Update & Sync while the
  // UI claimed a synchronization was in progress.
  private syncHealthHandler(data: any): void {
    if (data.type === 'queue-unreachable') {
      this.toastService.error(
        'Sync queue unreachable — Redis may be down. Syncing is paused until it recovers.',
        'Sync problem'
      );
      return;
    }
    if (data.type === 'stalled') {
      const {remaining, minutes} = data.payload || {};
      this.toastService.warning(
        `Sync has not progressed in ${minutes} minutes with ${remaining} items outstanding.`,
        'Sync stalled'
      );
      return;
    }
    if (data.type === 'stale-lock-released') {
      const held = data.payload?.heldMinutes;
      this.toastService.warning(
        `A sync lock left behind for ${held} minutes was cleared automatically. You can sync again.`,
        'Stale sync lock cleared'
      );
      return;
    }
  }

  private onceImportUpdateHandler: boolean = true;
  private importUpdateHandler(data: any): void {
    if (data.type === 'start') {
      this.progressBarsService.startImport(
        data.payload?.operation || 'update',
        data.payload?.user_name || 'Someone',
        data.payload?.count || 0
      );
      return;
    }
    if (data.type === 'progress') {
      this.progressBarsService.updateImportProgress(
        data.payload?.completed || 0,
        data.payload?.total || 0,
        data.payload?.percentage || 0
      );
      return;
    }
    // Named phase for the pre-row work (parsing, tag resolution). No percentage
    // is possible there, but naming it stops the bar reading as hung at 0%.
    if (data.type === 'phase') {
      this.progressBarsService.setImportPhase(data.payload?.phase || 'processing');
      return;
    }
    if (data.type === 'saving') {
      this.progressBarsService.startSavingPhase(
        data.payload?.completed || 0,
        data.payload?.total || 0,
        data.payload?.percentage || 0
      );
      return;
    }
    if (data.type === 'end') {
      this.progressBarsService.endImport();
      return;
    }
    if (data.type === 'complete') {
      this.progressBarsService.setBulkValue(0);
      this.infoService.productionImportUpdateComplete.next(true);
      // The verdict must reflect what actually changed — a run whose values
      // all matched the database used to announce "418,287 products updated
      // successfully", indistinguishable from a real update (or, worse, from
      // a silent failure).
      const processed = data.payload.count || 0;
      const changed = data.payload.changed;
      let message = '';
      let zeroChanges = false;
      if (changed === 0) {
        zeroChanges = true;
        message = `Import complete: ${processed.toLocaleString()} rows processed — no values changed (data already matches the catalog)`;
      } else if (changed > 0) {
        message = `Import complete: ${processed.toLocaleString()} rows processed — ${changed.toLocaleString()} product${changed === 1 ? '' : 's'} updated`;
      } else {
        // Older API without the changed counter
        message = `${processed.toLocaleString()} product${processed === 1 ? '' : 's'} updated successfully`;
      }
      if (data.payload.skippedCreates) {
        message += ` (${data.payload.skippedCreates.toLocaleString()} new parts skipped, not created)`;
      }
      if (data.payload.durationMs > 0) {
        const secs = Math.round(data.payload.durationMs / 1000);
        const m = Math.floor(secs / 60);
        const s = secs % 60;
        message += ` — total import time ${m > 0 ? m + 'm ' : ''}${s}s`;
      }
      if (data.payload.autoSync === 'started') {
        message += ' — Shopify sync started automatically';
      } else if (data.payload.autoSync) {
        message += ` — auto-sync ${data.payload.autoSync}`;
      }
      // Mark the durable summary as displayed so the on-load fallback
      // (header.checkLastImportSummary) doesn't repeat it after a refresh.
      if (data.payload.finishedAt) {
        localStorage.setItem('lastImportSummarySeen', data.payload.finishedAt);
      }
      if (this.onceImportUpdateHandler) {
        this.onceImportUpdateHandler = false;
        if (zeroChanges) {
          // Info-styled and sticky: a no-op import is the outcome users
          // misread as failure, so it stays until dismissed.
          this.toastService.info(message, 'Import Data', {
            timeOut: 0,
            closeButton: true
          });
        } else {
          this.toastService.success(message, 'Import Data', {
            timeOut: 10000
          });
        }
        this.gridService.gridApi?.setFilterModel(null);
        this.gridService.gridApi?.setFilterModel({
          imported: {
            filterType: 'set',
            values: [this.authService.currentUserValue._id]
          },
          status: {
            filterType: 'text',
            type: 'contains',
            filter: [20, 30]
          }
        });
        this.gridService.gridApi?.refreshServerSideStore();
        setTimeout(() => {
          this.onceImportUpdateHandler = true;
        }, 1000);
      }
      // this.progressBarsService.setImportUpdateValue(0);
      // this.gridService.gridApi?.setFilterModel(null);
      // this.gridService.gridApi?.setFilterModel({
      //   id: {
      //     filterType: 'text',
      //     type: 'contains',
      //     filter: data.returnIds
      //   }
      // });
    }
    if (data.message === 'progress') {
      // this.progressBarsService.setImportUpdateValue(1);
      // if (data.data.counter !== data.data.totalItems) {
      //   const val = (100 * data.data.counter) / data.data.totalItems;
      //   this.progressBarsService.setImportValue(val)
      // }
    }
  }

  private userHandler(data: any): void {
    if (data.type === 'logout') {
      if (data.payload && data.payload._id === this.authService?.currentUserValue?._id) {
        this.authService.logout();
      }
    }
  }

  private feedHandler(data: any): void {
    if (data.type === 'start') {
      // setTimeout(() => {
        this.progressBarsService.setShopifyPendingStatus(true);
      // }, 200);
    }
    if (data.type === 'stop') {
      this.progressBarsService.setShopifyPendingStatus(false);
      if (data.msg) {
        this.toastService.warning(data.msg);
      }
    }
    // if (data.message === '0x239359253') {
    //   this.progressBarsService.setShopifyPendingStatus(true);
    // } else if (data.message === '0x0001') {
    //   this.progressBarsService.setShopifyPendingStatus(false);
    //   clearTimeout(this.startFeedGeneratorMessageTimer);
    // } else if (data.message === '0x9999') {
    //   this.progressBarsService.setShopifyPendingStatus(true);
    //   this.startFeedGeneratorMessageTimer = setTimeout(() => {
    //     this.toastService.info('Please wait. Feed is being generated...');
    //   }, 1000);
    // }
  }
  private newBulkEditHandler(data: any): void {
    if (data.type === 'error') {
      this.progressBarsService.setBulkValue(0);
      this.toastService.error(`Please make sure the function is correct. Message: ${data.message}`, 'Bulk edit error');
    }
  }

  private onceBulkEditMessage: any = true;
  private bulkEditHandler(data: any): void {
    if (data.message === '0x1811') {
      this.progressBarsService.setBulkValue(1);

      // clearTimeout(this.bulkEditTimer);
      // this.bulkEditTimer = setTimeout(() => {
      //   this.toastService.info('Bulk editing in progress...');
      // }, 2000);
      // this.bulkProgressBarPending = true;
    }

    if (data.message === '0x0000') {
      // this.bulkProgressBarPending = false;
      this.progressBarsService.setBulkValue(0);
      // clearTimeout(this.bulkEditTimer);
      if (this.onceBulkEditMessage) {
        this.onceBulkEditMessage = false;
        this.toastService.success('Bulk edit completed successfully!');
        setTimeout(() => {
          this.onceBulkEditMessage = true;
        }, 1000);
      }
    }
  }

  onceShopifyHandlerMessage: boolean = true;
  onceShopifyHandlerErrorMessage: boolean = true;
  private shopifyCompleteHandler(data: any): void {
    this.onceShopifyHandlerMessage = false;

    // Clear any periodic sync validation since sync is complete
    clearInterval(this.syncInProgressChecker);
    this.progressBarsService.clearBulkSyncStatus();
    // The generating-feed banner has no completion event of its own — dismiss
    // it when the sync it fed reports complete.
    this.progressBarsService.endImport();

    // Legacy progress bar reset
    this.progressBarsService.setShopifyValue(0);
    this.progressBarsService.setShopifyPendingStatus(false);
    this.progressBarsService.setShopifyCounter(0);

    // Enhanced sync progress complete
    this.progressBarsService.completeSync();

    // Reset sync counters
    this.shopifySyncComplete = 0;
    this.shopifySyncTotalItems = 0;
    this.shopifySyncInitialTotal = 0;

    // CRITICAL FIX: Refresh ALL grids to show updated sync status
    // This ensures products no longer show "Pending Sync" after successful sync
    // We need to refresh all grids regardless of which is active
    // BUT skip if user is editing to prevent focus loss
    this.schedulePostSyncRefresh();

    this.toastService.success('All choosen products have been synced successfully!', new Date().toLocaleString(), {
      timeOut: 10000,
      // extendedTimeOut: 0,
      closeButton: true,
    });
    setTimeout(() => {
      this.onceShopifyHandlerMessage = true;
    }, 3000);
  }

  onceShopifyImagesHandlerMessage: boolean = true;
  onceShopifyImagesHandlerErrorMessage: boolean = true;
  private shopifyImagesCompleteHandler(data: any): void {
    this.onceShopifyImagesHandlerMessage = false;
    this.progressBarsService.setShopifyValue(0);
    this.progressBarsService.setShopifyPendingStatus(false);
    this.progressBarsService.setShopifyCounter(0);

    this.toastService.success('The images for all selected products were successfully synchronized!', new Date().toLocaleString(), {
      timeOut: 10000,
      // extendedTimeOut: 0,
      closeButton: true,
    });
    setTimeout(() => {
      this.onceShopifyImagesHandlerMessage = true;
    }, 3000);
  }

  private shopifySyncStartHandler(data: any): void {
    this.shopifySyncInitialTotal = data.totalItems || 0;
    this.shopifySyncTotalItems = data.totalItems || 0;
    this.shopifySyncComplete = data.completedItems || 0;

    this.progressBarsService.startSync(this.shopifySyncInitialTotal);
    this.progressBarsService.setShopifyPendingStatus(false);
  }

  private shopifySyncUpdateHandler(data: any): void {
    // Handle sync update when items are added to existing sync
    this.shopifySyncInitialTotal = data.totalItems || this.shopifySyncInitialTotal;
    this.shopifySyncTotalItems = data.totalItems || this.shopifySyncTotalItems;
    this.shopifySyncComplete = data.completedItems || 0;

    this.progressBarsService.updateSyncProgress(this.shopifySyncComplete, this.shopifySyncInitialTotal);
  }

  private shopifyCounterHandler(data: any): void {
    const totalItems = data.totalItems || this.shopifySyncInitialTotal || 0;
    const completedItems = data.completedItems || 0;
    const totalWaiting = data.totalWaiting || 0;

    // Update local tracking
    this.shopifySyncComplete = completedItems;
    this.shopifySyncTotalItems = totalItems;

    if (totalWaiting !== 0) {
      this.progressBarsService.setShopifyPendingStatus(false);
    }

    // Legacy progress bar updates (for backward compatibility)
    const percentage = totalItems > 0 ? (100 * completedItems) / totalItems : 0;
    this.progressBarsService.setShopifyValue(percentage);
    this.progressBarsService.setShopifyCounter(totalWaiting);

    // Enhanced sync progress update with correct values
    this.progressBarsService.updateSyncProgress(completedItems, totalItems);

    // Check if sync is complete
    if (totalWaiting === 0 && totalItems > 0) {
      this.shopifySyncComplete = 0;
      this.shopifySyncInitialTotal = 0;
      this.progressBarsService.setShopifyValue(0);
      this.progressBarsService.setShopifyCounter(0);
      this.progressBarsService.completeSync();
      clearInterval(this.syncInProgressChecker);
      this.infoService.getInfoMessage();
    }
  }

  private shopifyErrorsHandler(data: any): void {
    // If there are errors and no more items waiting, complete the sync
    if (data.errors && data.totalWaiting === 0) {
      this.shopifySyncComplete = 0;
      this.shopifySyncInitialTotal = 0;
      this.progressBarsService.setShopifyValue(0);
      this.progressBarsService.setShopifyCounter(0);
      this.progressBarsService.setShopifyPendingStatus(false);
      this.progressBarsService.completeSync();
      clearInterval(this.syncInProgressChecker);
    }

    this.toastService.error(`${data.errors} products failed to sync. Click on the message to see them.`).onTap.subscribe(() => {
      this.gridService.productionGridApi?.setFilterModel(null);
      this.gridService.productionGridApi?.setFilterModel({
        status: {
          filterType: 'text',
          type: 'contains',
          filter: [80]
        }
      });
    });
  }

  // Track periodic sync status validation during active syncs
  private syncInProgressChecker: any;

  private shopifyHandler(data: any): void {
    clearTimeout(this.startFeedGeneratorMessageTimer);
    if (data.totalWaiting === 0 ) {
      // Clear the periodic checker if sync is complete
      clearInterval(this.syncInProgressChecker);
    } else {
      this.progressBarsService.setShopifyPendingStatus(false);

      // Start periodic status validation during sync
      // This ensures status updates even if some WebSocket messages are lost
      this.startPeriodicSyncValidation();

      // FALLBACK: If we never got a proper start message, initialize here
      if (this.shopifySyncInitialTotal === 0 && data.totalWaiting > 0) {
        this.shopifySyncInitialTotal = data.totalWaiting;
        this.progressBarsService.startSync(data.totalWaiting);
      }
    }

    // if (data.totalWaiting === 0 && this.onceShopifyHandlerErrorMessage && data.errors) {
    //   this.onceShopifyHandlerErrorMessage = false;
    //   this.progressBarsService.setShopifyPendingStatus(false);
    //   this.toastService.error(`${data.errors} products failed to sync. Click on the message to see them.`).onTap.subscribe(() => {
    //     this.gridService.productionGridApi?.setFilterModel(null);
    //     this.gridService.productionGridApi?.setFilterModel({
    //       status: {
    //         filterType: 'text',
    //         type: 'contains',
    //         filter: [80]
    //       }
    //     });
    //   });
    //   setTimeout(() => {
    //     this.onceShopifyHandlerErrorMessage = true;
    //   }, 2000);
    // }
  }

  private pingPong(): void {
    this.pongInterval = setInterval(() => {
      if (this.webSocket.pong) {
        this.webSocket.pong();
      }
    }, 30000 + 1000);
  }

  private onError = (): void => {
    this.infoService.$appReady.next(false);
    this.connected = false;
    clearInterval(this.pongInterval);
    // Clear sync checker if WebSocket disconnects
    clearInterval(this.syncInProgressChecker);
  }

  private onClose = (): void => {
    this.infoService.$appReady.next(false);
    this.connected = false;
    clearInterval(this.pongInterval);
    // Clear sync checker if WebSocket disconnects
    clearInterval(this.syncInProgressChecker);
  }
}
